import { useState } from "react"
import { Badge, Button, Input, FormFeedback } from "reactstrap"

const ComplimentaryItemBadge = ({
  item,
  onEdit,
  onDelete,
  showActions = true,
}) => {
  const [hovered, setHovered] = useState(false)

  const displayName = item?.custom_name || item?.name || "Unnamed Item"

  return (
    <span
      className="complimentary-badge-wrapper d-inline-block position-relative"
      onMouseEnter={() => showActions && setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Badge className="badge-soft-success border-0 px-2 py-1">
        {displayName}
      </Badge>
      {showActions && hovered && (
        <span className="complimentary-badge-actions">
          <Button
            color="light"
            size="sm"
            className="complimentary-badge-btn"
            onClick={() => onEdit && onEdit(item)}
            title="Edit"
          >
            <i className="bx bx-pencil" />
          </Button>
          <Button
            color="light"
            size="sm"
            className="complimentary-badge-btn"
            onClick={() => onDelete && onDelete(item)}
            title="Delete"
          >
            <i className="bx bx-trash" />
          </Button>
        </span>
      )}
    </span>
  )
}

export default ComplimentaryItemBadge
